import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-control",
  "use": "arrow-control-usage",
  "viewBox": "0 0 7.4 8.5",
  "content": "<symbol viewBox=\"0 0 7.4 8.5\" id=\"arrow-control\">\n\t<path d=\"M0,3.7L3.7,0l3.7,3.7l-1,1.1L4.5,2.9c0,0.9,0.1,1.8,0.1,2.3v3.3H2.9V5.2c0-0.5,0-1.4,0.1-2.3L1,4.8L0,3.7z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/controls/sprite/arrow-control.svg
// module id = oMpi
// module chunks = 0